import { defaultProps } from "./defaultProps";

const MuiTypography = {
  defaultProps,
};

export { MuiTypography };
